module.exports = __webpack_public_path__ + "media/inserate/assets/images/medium-cf81ae4b29ac55a20aa1373f3581a302.png";